export const AUDIO = 'Audio';
export const COVER_PHOTO = 'CoverPhoto';
export const IMAGE = 'Image';
export const IMAGES_VIDEOS = 'ImagesVideos';
export const TEXT = 'Text';
export const TRIBUTE_VIDEO = 'TributeVideo';
export const VIDEO = 'Video';
export const TRIBUTE_VIDEO_MUSIC = 'TributeVideoMusic';
export const STOCK_CLIP = 'StockClip';
export const PLAYLIST = 'Playlist';
export const TEXT_OVERLAY = 'TextOverlay';
